import "App.css";
import { useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { store } from "store/store";
import ChoosePlans from "views/ChoosePlans/ChoosePlans";
import { Congratulations } from "views/DonateFlow/Congratulations/Congratulations";
import OrganizationEvents from "views/OrganizationProfile/OrganizationEvents/OrganizationEvents";
import Checkout from "views/PaymentFlow/Checkout/Checkout";
import Program from "views/ProjectManagement/Program/Program";
import SignInFlow from "views/SignInFlow/SignInFlow";
import ResetPassword from "views/SignInFlow/SignInForgotPassword/ResetPassword";

import PostComments from "components/common/PostCard/PostComments";
import PrivateRoute from "components/PrivateRoute";
import PublicRoute from "components/PublicRoute";
import OwnerRoute from "components/OwnerRoute";
import CreateCampaign from "views/OrganizationProfile/CreateFundraising/CreateCampaign";
import CreateProject from "views/OrganizationProfile/CreateProject/CreateProject";
import CreateEvent from "views/OrganizationProfile/Events/CreateEvent";
import Events from "views/OrganizationProfile/Events/TabEvents/Events";
import OrganizationHome from "views/OrganizationProfile/OrganizationHome/OrganizationHome";
import ProjectMainBoard from "views/ProjectManagement/Program/Projects/ProjectMainBoard";

import Feed from "views/Feed/Feed";
import CreateOrganizationPage from "views/OrganizationProfile/CreateOrganization/CreateOrgMain/CreateOrganizationPage";
import FundraisingDetails from "views/FundraisingDetails";
import DonationDetail from "views/ProjectManagement/Program/Projects/DonationDetails/DonationDetail";
import Projects from "views/ProjectManagement/Program/Projects/Projects";
import { DonateFlow } from "views/DonateFlow/DonateFlow";

// for directory structure, the following link was used: https://www.taniarascia.com/react-architecture-directory-structure/

function App() {
  const [showThankYou, setShowThankYou] = useState(false);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <div className="app" style={{ backgroundColor: "#fef9fa" }}>
          <Routes>
            <Route
              path="/feed"
              element={
                <PrivateRoute>
                  <Feed />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PublicRoute>
                  <SignInFlow />
                </PublicRoute>
              }
            />
            <Route
              path="/payments"
              element={
                <PrivateRoute>
                  <ChoosePlans />
                </PrivateRoute>
              }
            />
            <Route
              path="/checkout"
              element={
                <PrivateRoute>
                  <Checkout />
                </PrivateRoute>
              }
            />
            <Route
              path="/donate"
              element={
                <PrivateRoute>
                  <DonateFlow />
                </PrivateRoute>
              }
            />
            <Route path={"/congratulations"} element={<Congratulations />} />
            <Route path="post/:postId" element={<PostComments />} />
            <Route
              path="/organization/new"
              element={
                <PrivateRoute>
                  <CreateOrganizationPage />
                </PrivateRoute>
              }
            />
            <Route
              path="profile/:publicUserId"
              element={
                <PrivateRoute>
                  <OrganizationEvents />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="home" replace />} />
              <Route path="home" element={<OrganizationHome />} />
              <Route path="events" element={<Events />} />
              {/* <Route path="events/:eventId" element={<EventDetail />} /> */}
              <Route path="projects" element={<Projects />} />
              <Route
                path="projects/:projectId"
                element={<ProjectMainBoard />}
              />
            </Route>
            <Route
              path="/org"
              element={
                <PrivateRoute>
                  <OrganizationEvents />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="home" replace />} />
              <Route path="home" element={<OrganizationHome />} />
              <Route path="events" element={<Events />} />
              <Route path="events/new" element={<CreateEvent />} />
              {/* <Route path="events/:eventId" element={<EventDetail />} /> */}
              <Route path="events/:eventId/edit" element={<CreateEvent />} />
              <Route path="projects" element={<Projects />} />
              <Route path="projects/new" element={<CreateProject />} />

              <Route
                path="projects/:projectId"
                element={<ProjectMainBoard />}
              />
              <Route
                path="projects/:projectId/events"
                element={<Navigate to="new" replace />}
              />
              <Route
                path="projects/:projectId/events/new"
                element={<CreateEvent />}
              />
              <Route
                path="projects/:projectId/fundraising/new"
                element={<CreateCampaign />}
              />
              <Route
                path="projects/:projectId/fundraising/:campaignId"
                element={<DonationDetail />}
              />
              {/* 
              <Route path="programs" element={<Programs />}>
                <Route path="/org/programs" element={<ProgramMainBoard />} />
                <Route path=":programId/projects" element={<Projects />} />
                <Route
                  path=":programId/projects/new"
                  element={<CreateProject />}
                />
                <Route
                  path=":programId/projects/:projectId"
                  element={<ProjectMainBoard />}
                />
                <Route
                  path=":programId/projects/:projectId/events"
                  element={<Navigate to="new" replace />}
                />
                <Route
                  path=":programId/projects/:projectId/events/new"
                  element={<CreateEvent />}
                />
              </Route>
              <Route path="programs/new" element={<CreateProgram />} /> */}
            </Route>
            <Route path={"/reset"} element={<ResetPassword />} />
            <Route
              path="/program"
              element={
                <PrivateRoute>
                  <Program />
                </PrivateRoute>
              }
            />{" "}
            <Route
              path="fundraising/:fundraiserId"
              element={
                <PrivateRoute>
                  <FundraisingDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="fundraising/:fundraiserId/edit"
              element={ 
                <PrivateRoute>
                    <OwnerRoute><CreateCampaign/></OwnerRoute>
                  </PrivateRoute>}
            />
          </Routes>
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
